import { BrowserDetector } from 'modules/application/misc/BrowserDetector';
import { v4 as uuid } from 'uuid';
import * as BlipSdk from 'blip-sdk';
import * as WebSocketTransport from 'lime-transport-websocket';
import moment from 'moment';
import './Check.scss';
import exceptionFormatter from 'exception-formatter'; /* eslint-disable */
var PageStatus;
(function (PageStatus) {
    PageStatus["Loading"] = "LOADING";
    PageStatus["Done"] = "DONE";
    PageStatus["Ready"] = "READY";
})(PageStatus || (PageStatus = {}));
var ProbeStatus;
(function (ProbeStatus) {
    ProbeStatus["Success"] = "SUCCESS";
    ProbeStatus["Failed"] = "FAILED";
    ProbeStatus["Waiting"] = "WAITING";
})(ProbeStatus || (ProbeStatus = {}));
class Probe {
    static $inject = ['props'];
    constructor(props) {
        this.executionTime = '';
        this.statusMessage = '';
        Object.assign(this, {
            ...props,
            exception: props?.exception?.stack
                ? exceptionFormatter(props.exception, { format: 'html' })
                : JSON.stringify(props.exception),
        });
    }
}
Probe.$inject = ['props'];
export class CheckController {
    static $inject = ['MESSAGINGHUBWEBSOCKETSCHEME', 'MESSAGINGHUBWEBSOCKETHOSTNAME', 'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT', 'MESSAGINGHUBWEBSOCKETPORT', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN', 'BLIP_WEBSOCKET_SCHEME', 'BLIP_WEBSOCKET_HOSTNAME', 'BLIP_WEBSOCKET_HOSTNAME_TENANT', 'BLIP_WEBSOCKET_PORT', 'BLIP_ACCOUNT_ISSUER', 'OMNI_DOMAIN', 'OMNI_WEBSOCKET_HOSTNAME', 'OMNI_WEBSOCKET_HOSTNAME_TENANT', 'PROXY_BASE_URL', '$http', '$translate', 'TenantService'];
    constructor(MESSAGINGHUBWEBSOCKETSCHEME, MESSAGINGHUBWEBSOCKETHOSTNAME, MESSAGINGHUBWEBSOCKETHOSTNAMETENANT, MESSAGINGHUBWEBSOCKETPORT, MESSAGINGHUBDOMAIN, BLIP_DOMAIN, BLIP_WEBSOCKET_SCHEME, BLIP_WEBSOCKET_HOSTNAME, BLIP_WEBSOCKET_HOSTNAME_TENANT, BLIP_WEBSOCKET_PORT, BLIP_ACCOUNT_ISSUER, OMNI_DOMAIN, OMNI_WEBSOCKET_HOSTNAME, OMNI_WEBSOCKET_HOSTNAME_TENANT, PROXY_BASE_URL, $http, $translate, TenantService) {
        'ngInject';
        this.MESSAGINGHUBWEBSOCKETSCHEME = MESSAGINGHUBWEBSOCKETSCHEME;
        this.MESSAGINGHUBWEBSOCKETHOSTNAME = MESSAGINGHUBWEBSOCKETHOSTNAME;
        this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT = MESSAGINGHUBWEBSOCKETHOSTNAMETENANT;
        this.MESSAGINGHUBWEBSOCKETPORT = MESSAGINGHUBWEBSOCKETPORT;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.BLIP_WEBSOCKET_SCHEME = BLIP_WEBSOCKET_SCHEME;
        this.BLIP_WEBSOCKET_HOSTNAME = BLIP_WEBSOCKET_HOSTNAME;
        this.BLIP_WEBSOCKET_HOSTNAME_TENANT = BLIP_WEBSOCKET_HOSTNAME_TENANT;
        this.BLIP_WEBSOCKET_PORT = BLIP_WEBSOCKET_PORT;
        this.BLIP_ACCOUNT_ISSUER = BLIP_ACCOUNT_ISSUER;
        this.OMNI_DOMAIN = OMNI_DOMAIN;
        this.OMNI_WEBSOCKET_HOSTNAME = OMNI_WEBSOCKET_HOSTNAME;
        this.OMNI_WEBSOCKET_HOSTNAME_TENANT = OMNI_WEBSOCKET_HOSTNAME_TENANT;
        this.PROXY_BASE_URL = PROXY_BASE_URL;
        this.$http = $http;
        this.$translate = $translate;
        this.TenantService = TenantService;
        this.probes = [];
        this.status = PageStatus.Ready;
        this.tenantPrefix = this.TenantService.getTenantPrefixFromUrl();
    }
    async start() {
        try {
            this.status = PageStatus.Loading;
            this.probes = [];
            await this.withPerformance([
                this.checkForBrowserVersion,
                this.checkForMsgingNetConnection,
                this.checkForBlipAiConnection,
                this.checkForOmnConnection,
                this.checkForExtenalConnection,
            ]);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.status = PageStatus.Done;
        }
    }
    async withPerformance(fns) {
        for (const fn of fns) {
            const initialMs = moment();
            const result = await fn.call(this);
            const finalMs = moment();
            this.probes = this.probes.concat({
                ...result,
                executionTime: finalMs.diff(initialMs, 'milliseconds'),
            });
        }
    }
    async checkForBrowserVersion() {
        const browserDetector = new BrowserDetector();
        const probeName = await this.$translate('status.browserVersion');
        const successMsg = await this.$translate('status.browserSuccessMsg');
        const failedMsg = await this.$translate('status.browserFailedMsg');
        try {
            if (browserDetector.isSupported()) {
                return new Probe({
                    name: probeName,
                    status: ProbeStatus.Success,
                    statusMessage: successMsg,
                });
            }
            return new Probe({
                name: probeName,
                status: ProbeStatus.Failed,
                statusMessage: failedMsg,
            });
        }
        catch (e) {
            return new Probe({
                name: probeName,
                status: ProbeStatus.Failed,
                statusMessage: failedMsg,
                exception: e,
            });
        }
    }
    async checkForMsgingNetConnection() {
        const messagingHubWebsocketHostname = this.TenantService.addTenantPrefixToUrl(this.MESSAGINGHUBWEBSOCKETHOSTNAMETENANT, this.tenantPrefix, this.MESSAGINGHUBWEBSOCKETHOSTNAME);
        const probeName = await this.$translate('status.msgingConnection', { messagingHubWebsocketHostname });
        const successMsg = await this.$translate('status.msgingSuccessMsg', { messagingHubWebsocketHostname });
        const failedMsg = await this.$translate('status.msgingFailedMsg', { messagingHubWebsocketHostname });
        const client = new BlipSdk.ClientBuilder()
            .withScheme(this.MESSAGINGHUBWEBSOCKETSCHEME)
            .withHostName(messagingHubWebsocketHostname)
            .withPort(this.MESSAGINGHUBWEBSOCKETPORT)
            .withDomain(this.MESSAGINGHUBDOMAIN)
            .withTransportFactory(() => new WebSocketTransport())
            .build();
        try {
            await client.connect();
            await this.doPing(client);
            return new Probe({
                name: probeName,
                status: ProbeStatus.Success,
                statusMessage: successMsg,
            });
        }
        catch (e) {
            return new Probe({
                name: probeName,
                status: ProbeStatus.Failed,
                statusMessage: failedMsg,
                exception: e,
            });
        }
        finally {
            client._transport.onClose = () => { };
            client.close();
        }
    }
    async checkForBlipAiConnection() {
        const blipWebsocketHostname = this.TenantService.addTenantPrefixToUrl(this.BLIP_WEBSOCKET_HOSTNAME_TENANT, this.tenantPrefix, this.BLIP_WEBSOCKET_HOSTNAME);
        const probeName = await this.$translate('status.blipAiConnection', { blipWebsocketHostname });
        const successMsg = await this.$translate('status.blipAiSuccessMsg', { blipWebsocketHostname });
        const failedMsg = await this.$translate('status.blipAiFailedMsg', { blipWebsocketHostname });
        const client = new BlipSdk.ClientBuilder()
            .withScheme(this.BLIP_WEBSOCKET_SCHEME)
            .withHostName(blipWebsocketHostname)
            .withPort(this.BLIP_WEBSOCKET_PORT)
            .withDomain(this.BLIP_DOMAIN)
            .withIssuer(this.BLIP_ACCOUNT_ISSUER)
            .withTransportFactory(() => new WebSocketTransport())
            .build();
        try {
            await client.connect();
            await this.doPing(client);
            return new Probe({
                name: probeName,
                status: ProbeStatus.Success,
                statusMessage: successMsg,
            });
        }
        catch (e) {
            return new Probe({
                name: probeName,
                status: ProbeStatus.Failed,
                statusMessage: failedMsg,
                exception: e,
            });
        }
        finally {
            client._transport.onClose = () => { };
            client.close();
        }
    }
    async checkForOmnConnection() {
        const omniHostname = this.TenantService.addTenantPrefixToUrl(this.OMNI_WEBSOCKET_HOSTNAME_TENANT, this.tenantPrefix, this.OMNI_WEBSOCKET_HOSTNAME);
        const probeName = await this.$translate('status.omniConnection', { omniHostname });
        const successMsg = await this.$translate('status.omniSuccessMsg', { omniHostname });
        const failedMsg = await this.$translate('status.omniFailedMsg', { omniHostname });
        const client = new BlipSdk.ClientBuilder()
            .withScheme(this.MESSAGINGHUBWEBSOCKETSCHEME)
            .withPort(this.MESSAGINGHUBWEBSOCKETPORT)
            .withHostName(omniHostname)
            .withDomain(this.OMNI_DOMAIN)
            .withTransportFactory(() => new WebSocketTransport())
            .build();
        try {
            await client.connect();
            await this.doPing(client);
            return new Probe({
                name: probeName,
                status: ProbeStatus.Success,
                statusMessage: successMsg,
            });
        }
        catch (e) {
            return new Probe({
                name: probeName,
                status: ProbeStatus.Failed,
                statusMessage: failedMsg,
                exception: e,
            });
        }
        finally {
            client._transport.onClose = () => { };
            client.close();
        }
    }
    async checkForExtenalConnection() {
        const probeName = await this.$translate('status.externalConnection');
        const successMsg = await this.$translate('status.externalSuccessMsg');
        const failedMsg = await this.$translate('status.externalFailedMsg');
        try {
            const { status } = await this.$http({
                method: 'GET',
                url: `${this.PROXY_BASE_URL}/ping`,
            });
            if (status === 200) {
                return new Probe({
                    name: probeName,
                    status: ProbeStatus.Success,
                    statusMessage: successMsg,
                });
            }
            throw new Error(`Something went wrong while requesting blip-external. Status response is ${status}`);
        }
        catch (e) {
            return new Probe({
                name: probeName,
                status: ProbeStatus.Failed,
                statusMessage: failedMsg,
                exception: e,
            });
        }
    }
    async doPing(client) {
        const promises = [];
        for (let i = 0; i < 50; i++) {
            promises.push(client.processCommand({
                id: uuid(),
                method: 'get',
                uri: '/ping'
            }));
        }
        await Promise.all(promises);
    }
}
CheckController.$inject = ['MESSAGINGHUBWEBSOCKETSCHEME', 'MESSAGINGHUBWEBSOCKETHOSTNAME', 'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT', 'MESSAGINGHUBWEBSOCKETPORT', 'MESSAGINGHUBDOMAIN', 'BLIP_DOMAIN', 'BLIP_WEBSOCKET_SCHEME', 'BLIP_WEBSOCKET_HOSTNAME', 'BLIP_WEBSOCKET_HOSTNAME_TENANT', 'BLIP_WEBSOCKET_PORT', 'BLIP_ACCOUNT_ISSUER', 'OMNI_DOMAIN', 'OMNI_WEBSOCKET_HOSTNAME', 'OMNI_WEBSOCKET_HOSTNAME_TENANT', 'PROXY_BASE_URL', '$http', '$translate', 'TenantService'];
